import React, { useState } from "react";
import moment from "moment";

const AirportFuelRestrictionValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  });

  let error = false;
  let errorMessage = "";

  if (props.additionalValues.mode === "FULL") {
    if (!error && !record.airportCode) {
      error = true;
      errorMessage = "Airport' is required";
    }  
  }

  if (!error && !record.restrictionType) {
    error = true;
    errorMessage = "Restriction Type' is required";
  }

  const fromDate = moment(record.fromDate);
  const toDate = moment(record.toDate);

  if (!error && (!record.fromDate || !fromDate.isValid())) {
    error = true;
    errorMessage = "'Effective From' is required";
  }
  if (!error && (!record.toDate || !toDate.isValid())) {
    error = true;
    errorMessage = "'Effective To' is required";
  }
  if (!error && toDate.isBefore(fromDate)) {
    error = true;
    errorMessage = "'Effective To' must be after or equal to 'Effective From'";
  }
  if (!error && record.restrictionType !== 'FULL' && (isNaN(record.restrictedQuantityUsg) || record.restrictedQuantityUsg <= 0)) {
    error = true;
    errorMessage = "A valid 'Quanity' is required";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default AirportFuelRestrictionValidator;
